<template>
    <div class="w-full pt-3 pb-1"><div class="w-full h-0.5 bg-LeichtesGrau bg-opacity-30 rounded-full"></div></div>
</template>